/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Notification(props) {
    return (
        <SvgIcon {...props}>
            <path d="M1.366,9.308C1.071,9.396,0.785,9.53,0.552,9.766c-0.739,0.744-0.733,1.951,0.005,2.692 c0.745,0.74,1.948,0.737,2.685-0.007c0.233-0.236,0.368-0.525,0.452-0.821C3.648,11.593,1.404,9.356,1.366,9.308z" />
            <path d="M11.398,3.489c0.066-0.045,0.14-0.073,0.198-0.132c0.508-0.51,0.508-1.334,0-1.843 c-0.507-0.509-1.33-0.509-1.838,0C9.71,1.563,9.689,1.625,9.649,1.68C7.819,0.596,5.431,0.826,3.854,2.398l0,0L3.849,2.402 C3.848,2.404,3.845,2.405,3.844,2.407S3.841,2.41,3.839,2.412L0.103,6.16l6.769,6.792l3.75-3.762l-0.001-0.001 C12.156,7.64,12.402,5.312,11.398,3.489z" />
        </SvgIcon>
    );
}

Notification.defaultProps = {
    viewBox: '0 0 12 16'
};

export default Notification;
